import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon, ArrowRightIcon, StarIcon } from 'lucide-react';
const comparisonData = [{
  feature: '200M+ local business records for matching',
  openmart: true,
  generic: false
}, {
  feature: 'Verified local business owner & decision-maker emails',
  openmart: true,
  generic: false
}, {
  feature: 'Tech stacks, social profiles, and 50+ enriched data fields',
  openmart: true,
  generic: false
}, {
  feature: 'Built-in email sequencing for local business outreach',
  openmart: true,
  generic: false
}, {
  feature: 'No hidden fees on local business data enrichment',
  openmart: true,
  generic: false
}, {
  feature: 'Sync enriched local business contacts to Salesforce & HubSpot',
  openmart: true,
  generic: true
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};
const rowVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};
export function EnrichmentComparison() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-4187">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-50/50 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-4188" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-4189">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-4190">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4191">
            Why teams choose <span className="text-blue-600" data-id="element-4192">Openmart</span> for
            local business data enrichment
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-4193">
            Compare our local business contact enrichment against other data
            providers.
          </p>
        </div>

        <div className="relative" data-id="element-4194">
          <div className="grid grid-cols-[2fr_1fr_1fr] md:grid-cols-[3fr_1.5fr_1.5fr] items-end mb-4 px-4 md:px-8" data-id="element-4195">
            <div className="pb-6" data-id="element-4196">
              <h3 className="text-xl font-bold text-slate-900" data-id="element-4197">
                Feature comparison
              </h3>
            </div>
            <div className="pb-6 text-center relative z-10" data-id="element-4198">
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-4199">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-4200" /> Recommended
              </div>
              <h3 className="text-xl font-bold text-slate-900" data-id="element-4201">Openmart</h3>
            </div>
            <div className="pb-6 text-center" data-id="element-4202">
              <h3 className="text-lg font-semibold text-slate-500" data-id="element-4203">
                Other enrichment tools
              </h3>
            </div>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} className="relative" data-id="element-4204">
            <div className="absolute top-0 bottom-0 bg-slate-50/80 rounded-[2rem] border border-slate-100 shadow-sm -z-10" style={{
            left: 'calc(50% + 0px)',
            width: '25%'
          }} data-id="element-4205" />
            <div className="flex flex-col" data-id="element-4206">
              {comparisonData.map((row, index) => {
              const isFirst = index === 0;
              const isLast = index === comparisonData.length - 1;
              return <motion.div key={index} variants={rowVariants} className="grid grid-cols-[2fr_1fr_1fr] md:grid-cols-[3fr_1.5fr_1.5fr] items-center group transition-colors hover:bg-slate-50/50 rounded-2xl" data-id="element-4207">
                    <div className="py-5 px-4 md:px-8 border-b border-slate-100 group-last:border-0" data-id="element-4208">
                      <span className="text-lg font-medium text-slate-700" data-id="element-4209">
                        {row.feature}
                      </span>
                    </div>
                    <div className={`py-5 px-2 flex justify-center items-center bg-slate-50/80 border-x border-slate-100/50 relative z-10 ${isFirst ? 'rounded-t-[2rem] border-t' : ''} ${isLast ? 'rounded-b-[2rem] border-b shadow-sm' : ''} ${!isLast ? 'border-b border-slate-100/50' : ''}`} data-id="element-4210">
                      {row.openmart ? <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center" data-id="element-4211">
                          <CheckIcon className="w-5 h-5 text-blue-600" strokeWidth={3} data-id="element-4212" />
                        </div> : <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center" data-id="element-4213">
                          <XIcon className="w-5 h-5 text-slate-300" strokeWidth={2} data-id="element-4214" />
                        </div>}
                    </div>
                    <div className="py-5 px-2 flex justify-center items-center border-b border-slate-100 group-last:border-0" data-id="element-4215">
                      {row.generic ? <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center" data-id="element-4216">
                          <CheckIcon className="w-5 h-5 text-slate-400" strokeWidth={2} data-id="element-4217" />
                        </div> : <div className="w-8 h-8 rounded-full flex items-center justify-center" data-id="element-4218">
                          <XIcon className="w-5 h-5 text-slate-200" strokeWidth={2} data-id="element-4219" />
                        </div>}
                    </div>
                  </motion.div>;
            })}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8,
          duration: 0.5
        }} className="mt-12 text-center" data-id="element-4220">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-4221">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-10 py-4 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition-colors text-lg" data-id="element-4222">
                Try for free <ArrowRightIcon className="w-5 h-5" data-id="element-4223" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}